export default __webpack_public_path__ + "static/10-d3cc9c50485e9fc7bee437965fa32f11.jpg";